import * as React from "react";
import { ArrowRight, Cog, Tractor, Truck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const serviceFeatures = [{
  title: "Petroleum & Petrochemical",
  description: "High-capacity thermal processing and downstream optimization for global refineries, ensuring efficient fuel and lubricant production cycles.",
  icon: Truck
}, {
  title: "Chemical Manufacturing",
  description: "Specialized infrastructure for complex chemical synthesis, ensuring rigorous safety compliance and maximum throughput for hazardous material processing.",
  icon: Tractor
}, {
  title: "Industrial Process Plants",
  description: "Turnkey engineering for large-scale industrial facilities, focusing on energy efficiency, system integration, and advanced process automation.",
  icon: Cog
}];
export default function TransportServices() {
  return;
}